import axios from "axios";

const stripWww = (h) => h.replace(/^www\./, "");
const resolveBackend = () => {
  const env = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return env;
  try {
    // Stesso sito aperto da www./non-www: usa l'origine corrente (niente CORS, cookie ok)
    if (stripWww(new URL(env).host) === stripWww(window.location.host)) return window.location.origin;
  } catch {}
  return env;
};

export const BACKEND_URL = resolveBackend();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Retry automatico delle GET su errori di rete / 5xx (es. durante un deploy)
const RETRY_DELAYS = [800, 2000];
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config || {};
  const status = error.response?.status;
  const retriable = (cfg.method || "get").toLowerCase() === "get" && (!error.response || status >= 500);
  const attempt = cfg.__retry || 0;
  if (!retriable || attempt >= RETRY_DELAYS.length) throw error;
  await new Promise((r) => setTimeout(r, RETRY_DELAYS[attempt]));
  return api({ ...cfg, __retry: attempt + 1 });
});

// Immagini dello storage: variante ridimensionata/WebP generata dal backend (/api/files/...?w=&fmt=webp)
export const imgUrl = (url, w = 600) => (url && url.startsWith("/api/files/") ? `${url}?w=${w}&fmt=webp` : url);
